import type { DependencyList } from "react";

import { useMemo } from "react";

export const useMemoObject = <T>(obj: T, deps: DependencyList): T => {
  // oxlint-disable-next-line react/exhaustive-deps
  return useMemo(() => obj, deps);
};
